<template>
  <div :class="$style['pt-time-slot']">
       <el-date-picker v-model="start_time" :type="type" :placeholder="placeholderStart" :value-format="valueFormat" @change="changeStart" :picker-options="pickerOptionsStart" :clearable="startClearable" :disabled="disabled" :default-time="defaultTime"></el-date-picker>
        <div :class="$style['date-font']">--</div>
        <el-date-picker v-model="end_time" :type="type" :placeholder="placeholderEnd"  :value-format="valueFormat"  @change="changeEnd" :picker-options="pickerOptionsEnd" :clearable="endClearable" :disabled="disabled" :default-time="defaultTime"></el-date-picker>
  </div>
</template>

<script>
// 组件class前缀
import { dateZero } from '@/utils/formUtils'
const prefixCls = 'pt-time-slot'
export default {
  name: 'pt-time-slot',
  props: {
    // 用于数组时，
    index: {
      type: [Number, String],
      default: ''
    },
    startTime: {
      type: [String, Number],
      default: ''
    },
    defaultTime: {
      type: [String, Array],
      default: ''
    },
    endTime: {
      type: [String, Number],
      default: ''
    },
    valueFormat: {
      type: String,
      default: 'timestamp'
    },
    startLabel: {
      type: String,
      default: 'startTime'
    },
    endLabel: {
      type: String,
      default: 'endTime'
    },
    type: {
      type: String,
      default: 'date'
    },
    placeholderStart: {
      type: String,
      default: '选择开始日期'
    },
    placeholderEnd: {
      type: String,
      default: '选择结束日期'
    },
    startClearable: {
      type: Boolean,
      default: true
    },
    endClearable: {
      type: Boolean,
      default: true
    },
    isClearStart: {
      type: Boolean,
      default: false
    },
    isClearEnd: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  watch: {
    startTime (val) {
      this.start_time = val
    },
    endTime (val) {
      this.end_time = val
    },
    isClearStart (val) {
      this.start_time = val ? '' : this.start_time
    },
    isClearEnd (val) {
      this.end_time = val ? '' : this.end_time
    }
  },
  data () {
    return {
      start_time: this.startTime,
      end_time: this.endTime,
      data: {},
      pickerOptionsStart: {
        disabledDate: time => {
          let dateZeroData = dateZero(this.end_time)
          if (this.end_time) {
            if (this.type === 'datetime') {
              if (time > dateZeroData) {
                return true
              }
            } else if (time > this.end_time) {
              return true
            }
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let dateZeroData = dateZero(this.start_time)
          if (this.type === 'datetime') {
            if (time < dateZeroData) {
              return true
            }
          } else if (time < this.start_time) {
            return true
          }
        }
      }
    }
  },
  methods: {
    changeStart (val) {
      this.data[this.startLabel] = val
      this.data[this.endLabel] = this.data[this.endLabel] || this.end_time
      //   this.data[this.endLabel] = this.end_time
      this.data.index = this.index
      this.$emit('change', this.data)
    },
    changeEnd (val) {
      this.data[this.endLabel] = this.timeFormat(val)
      //   this.data[this.endLabel] = this.type === 'datetime' ? val : (val && this.type !== 'datetime' ? val + 24 * 60 * 60 * 1000 - 1 : null)
      this.data[this.startLabel] = this.start_time
      this.data.index = this.index
      this.$emit('change', this.data)
    },
    timeFormat (val) {
      return this.type === 'datetime' ? val : (val && this.type !== 'datetime' ? val + 24 * 60 * 60 * 1000 - 1 : null)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-time-slot{
    display: flex;
}
.date-font {
    padding: 0 10px;
    height: 40px;
    line-height:40px;
    color: #E0E2E8
}

</style>
